"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var vue_typeahead_bootstrap_1 = __importDefault(require("vue-typeahead-bootstrap"));
var InputGeocodingSearch = /** @class */ (function (_super) {
    __extends(InputGeocodingSearch, _super);
    function InputGeocodingSearch() {
        var _this = _super.call(this) || this;
        _this.searchText = '';
        _this.features = [];
        _this.loader = true;
        _this.inputDisabled = false;
        return _this;
    }
    InputGeocodingSearch.prototype.onChangeDefaultPlaceCoordinates = function () {
        this.setDefaultPlaceCoordinates();
    };
    InputGeocodingSearch.prototype.setDefaultPlaceCoordinates = function () {
        var _this = this;
        if (!this.defaultPlaceCoordinates) {
            return;
        }
        this.inputDisabled = true;
        this.$indexDB.getValue('geocodingReverse', this.defaultPlaceCoordinates.lat + "," + this.defaultPlaceCoordinates.lng).then(function (result) {
            var _a;
            if (result) {
                _this.setDefaultInputValue((_a = result.value.properties) === null || _a === void 0 ? void 0 : _a.label);
            }
            else {
                _this.$geocodingCoordinatesService.request([_this.defaultPlaceCoordinates.lat, _this.defaultPlaceCoordinates.lng], _this.$i18n.locale).then(function (response) {
                    var _a;
                    _this.setDefaultInputValue((_a = response.features[0].properties) === null || _a === void 0 ? void 0 : _a.label);
                });
            }
            _this.inputDisabled = false;
        }, function (error) {
            throw new Error(error);
        });
    };
    InputGeocodingSearch.prototype.mounted = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$indexDB.createObjectStorage()];
                    case 1:
                        _a.sent();
                        this.setDefaultPlaceCoordinates();
                        return [2 /*return*/];
                }
            });
        });
    };
    InputGeocodingSearch.prototype.setDefaultInputValue = function (value) {
        this.$refs.geocodingInput.inputValue = value;
    };
    InputGeocodingSearch.prototype.serializer = function (feature) {
        var _a;
        return (_a = feature.properties) === null || _a === void 0 ? void 0 : _a.label;
    };
    InputGeocodingSearch.prototype.selected = function (feature) {
        if (!feature.geometry.coordinates || feature.geometry.type !== 'Point') {
            throw new Error('Not found coordinates');
        }
        var coordinates = {
            lat: feature.geometry.coordinates[1],
            lng: feature.geometry.coordinates[0]
        };
        this.$indexDB.putValue('geocodingReverse', { value: feature, id: coordinates.lat + "," + coordinates.lng });
        this.$emit('update:coordinates', coordinates);
    };
    InputGeocodingSearch.prototype.httpRequest = function () {
        var _this = this;
        if (this.searchText.length < 4) {
            return;
        }
        this.loader = true;
        this.$geocodingSearchService.request(this.searchText, this.country, this.$i18n.locale).then(function (response) {
            _this.features = response.features.sort(function (f1, f2) { var _a, _b, _c, _d; return ((_b = (_a = f1.properties) === null || _a === void 0 ? void 0 : _a.distance) !== null && _b !== void 0 ? _b : Number.POSITIVE_INFINITY) > ((_d = (_c = f2.properties) === null || _c === void 0 ? void 0 : _c.distance) !== null && _d !== void 0 ? _d : Number.POSITIVE_INFINITY) ? 1 : -1; });
            _this.loader = false;
        });
    };
    InputGeocodingSearch.prototype.onInput = function () {
        var _this = this;
        clearTimeout(this.lastWriteInputTimeout);
        this.lastWriteInputTimeout = setTimeout(function () {
            _this.httpRequest();
        }, 1000);
    };
    InputGeocodingSearch.prototype.onKeyUp = function () {
        if (this.searchText.length === 0) {
            this.$emit('update:coordinates', null);
        }
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: false })
    ], InputGeocodingSearch.prototype, "defaultPlaceCoordinates", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], InputGeocodingSearch.prototype, "country", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: false })
    ], InputGeocodingSearch.prototype, "placeholder", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], InputGeocodingSearch.prototype, "coordinates", void 0);
    __decorate([
        vue_property_decorator_1.Watch('defaultPlaceCoordinates')
    ], InputGeocodingSearch.prototype, "onChangeDefaultPlaceCoordinates", null);
    InputGeocodingSearch = __decorate([
        vue_property_decorator_1.Component({
            name: 'InputGeocodingSearch',
            components: {
                VueTypeaheadBootstrap: vue_typeahead_bootstrap_1.default
            }
        })
    ], InputGeocodingSearch);
    return InputGeocodingSearch;
}(vue_1.default));
exports.default = InputGeocodingSearch;
